import { filterableRoute } from './routes';

export const login = (returnTo?: string, location?: unknown) => {
  window.location.href = filterableRoute('/login', { returnTo, location });
};

export const logout = (returnTo?: string) => {
  window.location.href = filterableRoute('/logout', { returnTo });
};
